var map = {
	"./location-01.jpg": 37064,
	"./location-02.jpg": 64343,
	"./location-03.jpg": 76826,
	"./location-04.jpg": 13289,
	"./location-05.jpg": 58028,
	"./location-06.jpg": 18651,
	"./location-07.jpg": 33694,
	"./location-08.jpg": 61437,
	"./location-09.jpg": 35872,
	"./location-10.jpg": 83534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44911;